<div
  class="flex flex-col items-center gap-4 w-full max-w-[300px] m-auto"
  [ngClass]="{ 'pb-20': isOffLineMode() }"
  *transloco="let t; prefix: 'qrcode-module'"
>
  @if (hasOfflineToggle()) {
    <div class="flex flex-col gap-2">
      <div
        class="form-control rounded-box bg-base-200 dark:bg-base-100 px-2 w-fit mx-auto"
      >
        <label
          (click)="toggleOffLineMode($event)"
          class="label cursor-pointer items-center justify-center w-fit m-auto flex gap-2"
        >
          <span class="label-text text-xs text-neutral-400">{{
            t("offline_mode")
          }}</span>
          <input
            type="checkbox"
            class="toggle toggle-xs !toggle-success"
            [checked]="isOffLineMode() ? 'checked' : ''"
          />
        </label>
      </div>

      <div *ngIf="isOffLineMode()" class="bg-primary p-2 rounded-box w-full">
        <h2
          class="text-[1.3rem] text-white my-0 mx-auto font-semibold text-center w-full"
        >
          {{ trigger() }}
        </h2>
      </div>

      @if (selectedPaymentAccount() && !isOffLineMode()) {
        <button
          (click)="addPaymentAccount.emit(true)"
          type="button"
          class="bg-base-200 border-[0.5px] border-gray-500 btn btn-xs flex flex-row font-normal gap-4 h-auto hover:bg-base-300 hover:border-neutral-400 items-center justify-between px-2 py-1 rounded-box text-base-content text-sm"
          [ngClass]="{
            '!pl-2': !selectedPaymentAccount(),
          }"
        >
          <div class="flex flex-row gap-3 justify-center items-center">
            <div class="rounded-full size-6 bg-neutral-400">
              <img
                src="/assets/icons/providers/{{
                  selectedPaymentAccount()?.payment_provider?.icon
                }}"
                class=""
                alt=""
              />
            </div>
            <div class="flex flex-col items-start">
              <span class="text-neutral-400 text-base mt-1">{{
                selectedPaymentAccount()?.number_display
              }}</span>
            </div>
          </div>
          <i
            class="fa-light fa-pen-to-square text-neutral-500 text-lg mr-1"
          ></i>
        </button>
      }
    </div>
  }

  <div
    class="border-4 border-base-100 bg-white dark:border-none rounded-box w-full"
  >
    <div #canvas id="canvas" class="w-auto flex flex-col items-center"></div>
  </div>

  @if (link() || !isOffLineMode()) {
    <div
      *ngIf="link() || !isOffLineMode()"
      class="flex flex-col flex-grow gap-2 w-full"
    >
      @if (canCopy()) {
        <div class="flex w-full justify-center">
          <label
            *ngIf="link() || paymentLink()"
            class="input input-bordered !bg-base-100 rounded-box flex w-full items-center gap-2 pr-0 relative z-10"
          >
            <input
              disabled
              type="text"
              class="grow"
              [value]="link() || paymentLink()"
            />
            <button
              class="btn btn-sm btn-primary dark:!text-white dark:border-white dark:hover:!bg-white dark:hover:!text-black rounded-box flex justify-center absolute right-2 z-20"
              (click)="copy()"
              [ngClass]="
                copying()
                  ? '!btn-success !bg-success !text-white dark:md:!btn-success dark:hover:md:!btn-success dark:hover:md:!text-white dark:hover:md:!bg-success dark:border-none'
                  : 'btn-outline bg-base-300'
              "
            >
              @if (copying()) {
                <span class=""> {{ t("copied") }} </span>
                <i class="fa-regular fa-check-circle text-lg"></i>
              } @else {
                <span class=""> {{ t("copy_link") }}</span>
                <i class="fa-regular fa-copy text-lg"></i>
              }
            </button>
          </label>
        </div>
      }
      @if (canDownload() || canShare()) {
        <div
          class="flex flex-grow gap-2 w-full max-w-[310px] m-auto items-center"
        >
          @if (canShare()) {
            <button
              class="btn btn-md btn-primary dark:!border-white dark:!text-white dark:hover:!bg-white dark:hover:!text-black rounded-box btn-outline flex flex-1 justify-center"
              (click)="share()"
              [disabled]="loading()"
            >
              @if (loading() && loadingTarget() === "share") {
                <span class="loading loading-spinner"></span>
              } @else {
                <span class="mt-1"> {{ t("share_link") }} </span>
                <i class="fa-solid fa-share-all text-lg"></i>
              }
            </button>
          }

          @if (canDownload()) {
            <button
              class="btn btn-md btn-primary dark:!border-white dark:!text-white dark:hover:!bg-white dark:hover:!text-black rounded-box btn-outline flex flex-1 justify-center"
              (click)="download()"
            >
              @if (loading() && loadingTarget() === "download") {
                <span class="loading loading-spinner"></span>
              } @else {
                <span class="mt-1"> {{ t("download") }} </span>
                <i class="fa-solid fa-download text-lg"></i>
              }
            </button>
          }
        </div>
      }
    </div>
  }
</div>
